export default "__VITE_ASSET__BkX6LRlf__"